import React, { useState } from "react";
import { 
  Container, 
  Typography, 
  Box, 
  Tabs, 
  Tab, 
  Paper, 
  Button,
  LinearProgress,
  Card,
  CardHeader,
  CardContent,
  Divider
} from "@mui/material";
// import { toast } from 'react-toastify';
import {
  Assignment as AssignmentIcon,
  Quiz as ExamIcon,
  CloudUpload as UploadIcon
} from "@mui/icons-material";
import AssignmentManagement from "./AssignmentManagement";
import ExamManagement from "./ExamManagement";

// const FileUploadTest = () => {
//   const [file, setFile] = useState(null);
//   const [isUploading, setIsUploading] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [result, setResult] = useState(null);

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     setFile(selectedFile);
//     setResult(null);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!file) return;

//     const formData = new FormData();
//     formData.append('file', file);

//     setIsUploading(true);
//     setProgress(0);
//     setResult(null);

//     try {
//       const xhr = new XMLHttpRequest();
      
//       xhr.upload.onprogress = (event) => {
//         if (event.lengthComputable) {
//           const percentComplete = Math.round((event.loaded / event.total) * 100);
//           setProgress(percentComplete);
//         }
//       };

//       xhr.onload = () => {
//         if (xhr.status >= 200 && xhr.status < 300) {
//           const response = JSON.parse(xhr.responseText);
//           setResult(response);
//           toast.success('Upload successful!');
//         } else {
//           const error = JSON.parse(xhr.responseText);
//           throw new Error(error.message || 'Upload failed');
//         }
//       };

//       xhr.onerror = () => {
//         throw new Error('Network error during upload');
//       };

//       xhr.open('POST', 'http://localhost:4001/api/admin/exams/upload-test', true);
//       const token = localStorage.getItem('token');
//       xhr.setRequestHeader('Authorization', `Bearer ${token}`);
//       xhr.send(formData);

//     } catch (error) {
//       console.error('Upload error:', error);
//       toast.error(`Upload failed: ${error.message}`);
//       setResult({ error: error.message });
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   return (
//     <Card>
//       <CardHeader title="File Upload Test" />
//       <Divider />
//       <CardContent>
//         <form onSubmit={handleSubmit}>
//           <Box mb={3}>
//             <Button
//               variant="contained"
//               component="label"
//               startIcon={<UploadIcon />}
//               disabled={isUploading}
//             >
//               Select File
//               <input
//                 type="file"
//                 hidden
//                 onChange={handleFileChange}
//                 disabled={isUploading}
//               />
//             </Button>
//             {file && (
//               <Typography variant="body2" sx={{ mt: 1, ml: 1, display: 'inline-block' }}>
//                 Selected: {file.name} ({(file.size / (1024 * 1024)).toFixed(2)} MB)
//               </Typography>
//             )}
//           </Box>

//           {isUploading && (
//             <Box mb={3}>
//               <LinearProgress 
//                 variant="determinate" 
//                 value={progress} 
//                 sx={{ height: 8, borderRadius: 4, mb: 1 }}
//               />
//               <Typography variant="body2" color="text.secondary" align="center">
//                 Uploading... {progress}%
//               </Typography>
//             </Box>
//           )}

//           <Button
//             type="submit"
//             variant="contained"
//             color="primary"
//             disabled={!file || isUploading}
//             fullWidth
//           >
//             {isUploading ? 'Uploading...' : 'Start Upload Test'}
//           </Button>
//         </form>

//         {result && (
//           <Box mt={3}>
//             <Typography variant="subtitle1" gutterBottom>Upload Result:</Typography>
//             <Paper variant="outlined" sx={{ p: 2, bgcolor: 'background.default' }}>
//               <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
//                 {JSON.stringify(result, null, 2)}
//               </pre>
//             </Paper>
//           </Box>
//         )}
//       </CardContent>
//     </Card>
//   );
// };

// function TabPanel({ children, value, index, ...other }) {
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`content-tabpanel-${index}`}
//       aria-labelledby={`content-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// import React, { useState } from 'react';
// // Assuming you are using Material-UI
// import { Paper, Typography, Button, Box, LinearProgress } from '@mui/material';
// import UploadIcon from '@mui/icons-material/Upload';

const FileUploadTest = () => {
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [result, setResult] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setResult(null); // Clear previous results
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!file) return;

    const formData = new FormData();
    // This sends the file under the 'audio' field name.
    // If you need to handle images, you would use formData.append('image', file);
    formData.append('audio', file);

    setIsUploading(true);
    setProgress(0);
    setResult(null);

    const xhr = new XMLHttpRequest();

    // Listener for upload progress
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = Math.round((event.loaded / event.total) * 100);
        setProgress(percentComplete);
      }
    };

    // Listener for when the request is complete (fires for both success and HTTP errors)
    xhr.onload = () => {
      // The upload is finished, regardless of the outcome.
      setIsUploading(false);

      if (xhr.status >= 200 && xhr.status < 300) {
        // Success case
        const response = JSON.parse(xhr.responseText);
        setResult(response);
        console.log('Upload successful!', response);
      } else {
        // Handle HTTP errors (e.g., 400, 500)
        try {
          const errorResponse = JSON.parse(xhr.responseText);
          setResult({ error: errorResponse.message || `Request failed with status ${xhr.status}` });
          console.error('Upload failed with error:', errorResponse);
        } catch (parseError) {
          setResult({ error: `Request failed with status ${xhr.status}. Could not parse error response.` });
          console.error('Could not parse error response:', xhr.responseText);
        }
      }
    };

    // Listener for network errors (e.g., no connection)
    xhr.onerror = () => {
      setIsUploading(false); // The upload is finished
      setResult({ error: 'A network error occurred during the upload.' });
      console.error('Network error.');
    };

    // Open and send the request
    xhr.open('POST', 'http://localhost:4001/api/media/test-upload', true); // FIX: Removed trailing space
    const token = localStorage.getItem('token'); // Make sure you have a token in localStorage
    xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.send(formData);
  };

  return (
    <Paper sx={{ p: 3, mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        File Upload Test
      </Typography>
      <form onSubmit={handleSubmit}>
        <Box mb={3}>
          <Button
            variant="contained"
            component="label"
            startIcon={<UploadIcon />}
            disabled={isUploading}
          >
            Select File
            <input
              type="file"
              hidden
              onChange={handleFileChange}
              disabled={isUploading}
            />
          </Button>
          {file && (
            <Typography variant="body2" sx={{ mt: 1, ml: 1, display: 'inline-block' }}>
              Selected: {file.name} ({(file.size / (1024 * 1024)).toFixed(2)} MB)
            </Typography>
          )}
        </Box>

        {isUploading && (
          <Box mb={3}>
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{ height: 8, borderRadius: 4, mb: 1 }}
            />
            <Typography variant="body2" color="text.secondary" align="center">
              Uploading... {progress}%
            </Typography>
          </Box>
        )}

        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={!file || isUploading}
          fullWidth
        >
          {isUploading ? 'Uploading...' : 'Start Upload Test'}
        </Button>
      </form>

      {result && (
        <Box mt={3}>
          <Typography variant="subtitle1" gutterBottom>Upload Result:</Typography>
          <Paper variant="outlined" sx={{ p: 2, bgcolor: 'background.default' }}>
            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
              {JSON.stringify(result, null, 2)}
            </pre>
          </Paper>
        </Box>
      )}
    </Paper>
  );
};

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`content-tabpanel-${index}`}
      aria-labelledby={`content-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const ContentManagement = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
        py: 4,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            background: "white",
            backdropFilter: "blur(20px)",
            borderRadius: 4,
            border: "1px solid rgba(255,255,255,0.2)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
            p: 4,
            mb: 4,
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              background:
                "linear-gradient(45deg, #2196F3 0%, #1976D2 50%, #1565C0 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              textAlign: "center",
            }}
          >
            Content Management
          </Typography>
        </Box>

        <Paper
          sx={{
            width: "100%",
            background: "rgba(255,255,255,0.95)",
            backdropFilter: "blur(20px)",
            borderRadius: 3,
            border: "1px solid rgba(255,255,255,0.3)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          }}
        >
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="Content Management Tabs"
              sx={{
                '& .MuiTabs-flexContainer': {
                  justifyContent: 'flex-start',
                  gap: 1,
                },
                '& .MuiTab-root': {
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: '0.9375rem',
                  minHeight: 48,
                  minWidth: 'auto',
                  px: 2,
                  py: 1,
                  borderRadius: 2,
                  '&.Mui-selected': {
                    color: '#1976d2',
                    background: 'rgba(25, 118, 210, 0.08)',
                  },
                  '&:hover': {
                    background: 'rgba(25, 118, 210, 0.04)',
                    transform: 'translateY(-1px)',
                  },
                },
              }}
            >
              <Tab 
                icon={<AssignmentIcon />} 
                iconPosition="start" 
                label="Assignments" 
                id="tab-0" 
                aria-controls="tabpanel-0" 
              />
              <Tab 
                icon={<ExamIcon />} 
                iconPosition="start" 
                label="Exams" 
                id="tab-1" 
                aria-controls="tabpanel-1" 
              />
              <Tab 
                icon={<UploadIcon />} 
                iconPosition="start" 
                label="Upload Test" 
                id="tab-2" 
                aria-controls="tabpanel-2" 
              />
            </Tabs>
          </Box>

          <Box sx={{ p: 3 }}>
            <TabPanel value={tabValue} index={0}>
              <AssignmentManagement />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <ExamManagement />
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
              <FileUploadTest />
            </TabPanel>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default ContentManagement;
